/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon24Solid = forwardRef('ArrowShapeTriangleARightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19.066 10.508 8.664 4.133C7.498 3.418 6 4.257 6 5.625v12.75c0 1.367 1.498 2.206 2.664 1.492l10.402-6.375a1.75 1.75 0 0 0 0-2.984Z" })));
});
